import { WhatsAppIcon } from "./Logo";
import { FileText, Mail } from "lucide-react";
import { waLink, mailtoLink, WHATSAPP_ENABLED } from "../../config";
import { track } from "../../lib/tracking";

const base =
  "inline-flex items-center justify-center gap-2 font-semibold rounded-full transition-[transform,background-color,box-shadow,color] duration-300 focus-visible:outline-2 focus-visible:outline-offset-2";

const sizes = {
  sm: "px-4 py-2.5 text-sm",
  md: "px-6 py-3.5 text-[15px]",
  lg: "px-7 py-4 text-base",
};

export function WhatsAppButton({ message, size = "md", full = false, testid = "whatsapp-cta", label = "Richiedi Preventivo su WhatsApp", location = "generic" }) {
  if (!WHATSAPP_ENABLED) return null;
  return (
    <a
      href={waLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={() => track.whatsappClick(location)}
      className={`${base} ${sizes[size]} ${full ? "w-full" : ""} bg-[#25D366] text-white shadow-[0_8px_24px_-8px_rgba(37,211,102,0.7)] hover:bg-[#1ebe5b] hover:-translate-y-0.5`}
    >
      <WhatsAppIcon size={size === "lg" ? 22 : 19} />
      {label}
    </a>
  );
}

export function PreventivoButton({ size = "md", full = false, testid = "preventivo-cta", variant = "orange", label = "Richiedi Preventivo Online", href = "#preventivo", location = "generic" }) {
  // When WhatsApp is unavailable, the quote form becomes the primary channel:
  // auto-promote any secondary (outline) Preventivo button to the solid orange CTA.
  let v = variant;
  if (!WHATSAPP_ENABLED && (variant === "outlineDark" || variant === "outlineLight")) v = "orange";
  const variants = {
    orange: "bg-brand-orange text-white shadow-[0_8px_24px_-8px_rgba(242,140,40,0.75)] hover:bg-brand-orange-dark hover:-translate-y-0.5",
    outlineLight: "border border-white/30 text-white hover:bg-white hover:text-navy",
    outlineDark: "border border-navy/20 text-navy hover:bg-navy hover:text-white",
  };
  return (
    <a
      href={href}
      data-testid={testid}
      onClick={() => track.ctaClick(label, location)}
      className={`${base} ${sizes[size]} ${full ? "w-full" : ""} ${variants[v]}`}
    >
      <FileText size={size === "lg" ? 20 : 18} strokeWidth={2} />
      {label}
    </a>
  );
}

export function EmailButton({ size = "md", full = false, testid = "email-cta", variant = "outlineLight", label = "Invia una richiesta via Email", location = "generic" }) {
  const variants = {
    outlineLight: "border border-white/30 text-white hover:bg-white hover:text-navy",
    outlineDark: "border border-navy/20 text-navy hover:bg-navy hover:text-white",
  };
  return (
    <a
      href={mailtoLink()}
      data-testid={testid}
      onClick={() => track.emailClick(location)}
      className={`${base} ${sizes[size]} ${full ? "w-full" : ""} ${variants[variant]}`}
    >
      <Mail size={size === "lg" ? 20 : 18} strokeWidth={2} />
      {label}
    </a>
  );
}
